import React from "react"
import Header from "./Header"
import MemeGenerator from "./MemeGenerator"
import styles from "./style.css";

function App() {
    return (
        <div>
            <Header />
            <MemeGenerator />
        </div>
    )
}

export default App